// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daily-pickem-table-container {
  overflow-x: auto !important;
}
.daily-pickem-table-container .daily-pickem-table-header {
  color: white;
  font-weight: bold;
  cursor: pointer;
  padding: 12px 16px;
}
.daily-pickem-table-container .daily-pickem-table-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.daily-pickem-table-container .daily-pickem-username-column {
  padding: 8px 16px;
  cursor: pointer;
}
.daily-pickem-table-container .daily-pickem-username-column:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.daily-pickem-table-container .daily-pickem-username-text {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
}
.daily-pickem-table-container .daily-pickem-rank-text {
  font-size: 12px;
  color: #555;
}
.daily-pickem-table-container .daily-pickem-pick-box {
  height: 40px;
  width: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.daily-pickem-table-container .daily-pickem-empty-box {
  height: 40px;
  width: 40px;
  margin: 0 auto;
  border-radius: 4px;
}

@media (max-width: 900px) {
  .daily-pickem-table-container .daily-pickem-username-text {
    font-size: 12px;
  }
  .daily-pickem-table-container .daily-pickem-rank-text {
    font-size: 10px;
  }
  .daily-pickem-table-container .daily-pickem-pick-box,
  .daily-pickem-table-container .daily-pickem-empty-box {
    height: 32px;
    width: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/PoolPicks/DailyPickemPicks.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;AACI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AACN;AACM;EACE,0CAAA;AACR;AAGI;EACE,iBAAA;EACA,eAAA;AADN;AAGM;EACE,qCAAA;AADR;AAKI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AAHN;AAMI;EACE,eAAA;EACA,WAAA;AAJN;AAOI;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AALN;AAQI;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AANN;;AAUE;EAEI;IACE,eAAA;EARN;EAWI;IACE,eAAA;EATN;EAYI;;IAEE,YAAA;IACA,WAAA;EAVN;AACF","sourcesContent":[".daily-pickem-table-container {\n    overflow-x: auto !important;\n    \n    .daily-pickem-table-header {\n      color: white;\n      font-weight: bold;\n      cursor: pointer;\n      padding: 12px 16px;\n      \n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n    }\n    \n    .daily-pickem-username-column {\n      padding: 8px 16px;\n      cursor: pointer;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n    }\n    \n    .daily-pickem-username-text {\n      font-weight: 600;\n      font-size: 14px;\n      margin-bottom: 2px;\n    }\n    \n    .daily-pickem-rank-text {\n      font-size: 12px;\n      color: #555;\n    }\n    \n    .daily-pickem-pick-box {\n      height: 40px;\n      width: 40px;\n      margin: 0 auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 4px;\n    }\n    \n    .daily-pickem-empty-box {\n      height: 40px;\n      width: 40px;\n      margin: 0 auto;\n      border-radius: 4px;\n    }\n  }\n  \n  @media (max-width: 900px) {\n    .daily-pickem-table-container {\n      .daily-pickem-username-text {\n        font-size: 12px;\n      }\n      \n      .daily-pickem-rank-text {\n        font-size: 10px;\n      }\n      \n      .daily-pickem-pick-box,\n      .daily-pickem-empty-box {\n        height: 32px;\n        width: 32px;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
